const mediaLanding = {
    mixins: [mixins, mixin_viewport],
    data: function () {
        return {
            handler: "",
            sort: "",
            loading: true,
            page: 0,
            errorMsgs: [],
            hasMore: false,
            records: [],
            itemsPerRow: 2
        };
    },
    mounted() {
        this.loadMore();
    },
    methods: {
        loadMore() {
            this.loading = true;
            this.errorMsgs = [];
            this.page++;

            try {
                axios
                    .post(this.handler, { page: this.page, sort: this.sort })
                    .then((response) => {
                        var { hasError, errorMessages, data, hasMore } =
                            response.data;

                        if (hasError) {
                            this.handleError(errorMessages);
                            return false;
                        }

                        this.handleSuccess(data, hasMore);
                    })
                    .catch((errors) => {
                        this.handleError([errors]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleError(JSON.parse(err));
            }
        },
        handleError(errorMessages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
        },
        handleSuccess(data, hasMore) {
            this.hasMore = hasMore;
            this.records.push(...data);
            
            if(this.$refs.lightbox)
                this.$refs.lightbox.loadMoreComplete()
        },
        sortChanged(){
            this.reset()
            this.loadMore();
        },
        reset(){
            this.page = 0
            this.records = []
        },
        mediaClicked(e, item){
            const index = this.records.findIndex(x => x.id === item.id)
            this.$refs.lightbox.showItem(e, index);
        }
    },
    computed:{
        itemsPerRowClass(){
            return `items-per-row--${this.itemsPerRow}`
        }
    }
};
const mediaLandingApp = Vue.createApp(mediaLanding);
const mediaLandingDiv = document.querySelector("#mediaLanding");
if (mediaLandingDiv) {
    mediaLandingApp.directive("init", initDirective);
    mediaLandingApp.component("infinity-scroll", infinityScroll);
    mediaLandingApp.component("b-media-item--file", bMediaItemFile);
    mediaLandingApp.component("photo-item", photoItem);
    mediaLandingApp.component("media-item", mediaItem);
    mediaLandingApp.component("custom-lightbox", customLightbox);
    mediaLandingApp.mount(mediaLandingDiv);
}
